import type {UpdateEmploymentRequest} from '@rocket-ui/lk-api';
import {RegistrationWorkStatus} from './types';

export type WorkStatusOption = {
	value: RegistrationWorkStatus;
	label: string;
};

export function getSelfEmploymentStatusLabel(): string {
	return 'Самозанятый';
}

export function getWorkStatusOptions(): WorkStatusOption[] {
	return [
		{value: 'self_employment', label: getSelfEmploymentStatusLabel()},
		{value: 'individual', label: 'Физическое лицо'},
		{value: 'individual_entrepreneur', label: 'ИП'},
	];
}

export const buildEmploymentRequest = (workStatus: RegistrationWorkStatus): UpdateEmploymentRequest => ({
	kind: workStatus,
});
